export default __webpack_public_path__ + "static/simple-line-95a77bb985df533b56f87806e0742bef.png";